export const VTMN_ICON_VARIANT = {
  DEFAULT: 'default',
  BRAND: 'brand',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  ACTION: 'action',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  NEGATIVE: 'negative',
  WARNING: 'warning',
  POSITIVE: 'positive',
  INFORMATION: 'information',
  ACCENT: 'accent',
  VISITED: 'visited',
  REVERSED: 'reversed',
  PRIMARY_REVERSED: 'primary-reversed',
  ACTION_REVERSED: 'action-reversed',
  VISITED_REVERSED: 'visited-reversed',
};
